import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Fabbricato } from '../models/fabbricato';
import { ResourcefulService } from './resourcefulService';
import { baseUrl } from './api-config';



@Injectable({
  providedIn: 'root'
})
export class FabbricatoService extends ResourcefulService<Fabbricato>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, Fabbricato);
  }

  async aggiornaIndirizzoPreesistenza(fabbricatoId: number): Promise<Fabbricato> {
    const url = `${baseUrl}/fabbricati/${fabbricatoId}/aggiorna-indirizzo-preesistenza`;
    const response = await this._httpClient.post<{ data: any }>(url, {}).toPromise();
    return new Fabbricato().deserialize(response?.data);
  }
}
